import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

export class ClickEventButton extends Component {

  handleClick = (e) => {
    if (this.props.saving) {
      // prevent double click
      e.preventDefault();
    } else {
      this.props.onClick();
    }
  };

  render() {
    const { icon, saving, disabled, label = 'Click' } = this.props;
    return <RaisedButton
      type='button'
      label={label}
      disabled={disabled}
      icon={saving ? <CircularProgress size={25} thickness={2} /> : icon}
      onClick={this.handleClick}
      primary={!saving}
      style={{
        margin: '10px 24px',
        position: 'relative',
      }}
    />;
  }
}

ClickEventButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.element,
  saving: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

ClickEventButton.defaultProps = {
  icon: null
};

const mapStateToProps = state => ({
  saving: state.admin.saving,
});

export default connect(mapStateToProps)(ClickEventButton);



// WEBPACK FOOTER //
// ./src/components/button/ClickEventButton.js